import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { Fragment, useMemo } from 'react';
import { getTestIds } from 'seagull/utils/TestIds';
import { ChipConnector } from '~/components/AiSearchChips/ChipConnector/ChipConnector';
import { moveQuantifier, nextQuantifier, presentServiceEntries, setQuantifier } from './service-predicate';
import { ServiceConditionChip } from './ServiceConditionChip/ServiceConditionChip';
import { isFlattenableCondition } from './serviceConditions';
import { ServiceFlattenedChips } from './ServiceFlattenedChips';
import { toEntityCollection } from './serviceGrammar';
export const GetServicesChipsTID = (parentTestId)=>getTestIds(parentTestId);
export const ServicesChips = (param)=>{
    let { testId, grammar, services, autoOpenField, onChange } = param;
    const { ServicesChipsTestIds } = useMemo(()=>GetServicesChipsTID(testId), [
        testId
    ]);
    const collection = services;
    const emit = (next)=>onChange(toEntityCollection(grammar, next));
    const toggleQuantifier = (quantifier)=>{
        const target = nextQuantifier(collection, quantifier);
        if (target === quantifier) return;
        emit(moveQuantifier(collection, quantifier, target));
    };
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: presentServiceEntries(collection).map((param, index)=>{
            let { quantifier, predicate } = param;
            return /*#__PURE__*/ _jsxs(Fragment, {
                children: [
                    index > 0 && /*#__PURE__*/ _jsx(ChipConnector, _object_spread_props(_object_spread({}, grammar.connector), {
                        testId: ServicesChipsTestIds.AndConnector(index - 1),
                        tone: "and"
                    })),
                    isFlattenableCondition(grammar, predicate, quantifier) ? /*#__PURE__*/ _jsx(ServiceFlattenedChips, {
                        chipTestId: (field)=>ServicesChipsTestIds.Chip(quantifier, field),
                        grammar: grammar,
                        services: collection,
                        quantifier: quantifier,
                        predicate: predicate,
                        autoOpenField: autoOpenField,
                        onChange: emit
                    }) : /*#__PURE__*/ _jsx(ServiceConditionChip, {
                        testId: ServicesChipsTestIds.SummaryChip(quantifier),
                        grammar: grammar,
                        quantifier: quantifier,
                        predicate: predicate,
                        onToggleQuantifier: ()=>toggleQuantifier(quantifier),
                        onRemove: ()=>emit(setQuantifier(collection, quantifier, undefined))
                    })
                ]
            }, quantifier);
        })
    });
};
